import { useState, useEffect, useRef, useCallback } from "react";
import { IoChevronDown, IoChevronUp } from "react-icons/io5";
import { Link, useLocation } from "react-router-dom";
import { ROUTES } from "../../constant";
import { MENU_LABELS } from "../../constant/Menu_Labels";
import { setUser, useUser1 } from "../../redux/services/authSlice";
import { useDispatch, useSelector } from "react-redux";
import { getSingleStudent } from "../../redux/services/studentSlice";

const Sidebar = ({ isOpen, setSidebarOpen }) => {
  const dispatch = useDispatch();
  const sidebarRef = useRef(null);
  const { pathname } = useLocation();
  const [openMenus, setOpenMenus] = useState({});
  const { user1 } = useUser1();
  const singleUserData = useSelector((state) => state.student?.singleStudentData);

  // const menuItems = [
  //   {
  //     label: "Dashboard",
  //     path: ROUTES.HOME,
  //   },
  //   {
  //     label: "Flag Issues",
  //     children: [
  //       { label: "User Report", path: ROUTES.REPORTS.USER },
  //       { label: "Questions Report", path: ROUTES.REPORTS.QUESTION },
  //       { label: "Result Report", path: ROUTES.REPORTS.RESULT },
  //     ],
  //   },
  //   {
  //     label: "Reports",
  //     children: [
  //       { label: "Contest Wise Earning", path: ROUTES.EARNINGS.CONTEST_WISE },
  //       { label: "Subject Wise Earning", path: ROUTES.EARNINGS.SUBJECT_WISE },
  //       { label: "Slot Time Earning", path: ROUTES.EARNINGS.SLOT_TIME },
  //       { label: "User Earning", path: ROUTES.EARNINGS.USER },
  //       { label: "Classes Earning", path: ROUTES.EARNINGS.CLASSES },
  //     ],
  //   },
  //   {
  //     label: "Users",
  //     children: [
  //       { label: "All Users", path: ROUTES.USERS.BASE },
  //       { label: "User Data", path: ROUTES.USERS.DETAIL },
  //       { label: "Add New User", path: ROUTES.USERS.ADD },
  //       { label: "KYC Verification", path: ROUTES.USERS.KYC },
  //     ],
  //   },
  //   {
  //     label: "Contest Management",
  //     children: [
  //       { label: "All Contests", path: ROUTES.CONTEST.BASE },
  //       { label: "Contest Types", path: ROUTES.CONTEST.TYPE },
  //       { label: "Contest Earnings", path: ROUTES.EARNINGS.CONTEST_WISE },
  //       { label: "Goal Types", path: ROUTES.GOAL },
  //       { label: "Exam Types", path: ROUTES.EXAM_TYPE },
  //     ],
  //   },
  //   {
  //     label: "Courses",
  //     children: [
  //       { label: "All Courses", path: ROUTES.COURSES.BASE },
  //       { label: "Module", path: ROUTES.COURSES.MODULE },
  //       { label: "Course Lectures", path: ROUTES.COURSES.LECTURES },
  //       { label: "Course Purchase", path: ROUTES.COURSES.PURCHASE },
  //       { label: "Course FAQ", path: ROUTES.COURSES.FAQ },

  //     ],
  //   },
  //   {
  //     label: "Workshops",
  //     children: [
  //       { label: "All Workshops", path: ROUTES.WORKSHOPS.BASE },
  //       { label: "Workshop Register", path: ROUTES.WORKSHOPS.REGISTER },
  //       { label: "Workshop Lectures", path: ROUTES.WORKSHOPS.LECTURES },
  //       { label: "Workshop Testimonials", path: ROUTES.WORKSHOPS.TESTIMONIALS },
  //       { label: "Workshop FAQ", path: ROUTES.WORKSHOPS.FAQ },
  //     ],
  //   },
  //   {
  //     label: "Website Content",
  //     children: [
  //       { label: "Interface", path: ROUTES.WEBSITE.INTERFACE },
  //       { label: "About Us", path: ROUTES.WEBSITE.ABOUT_US },
  //       { label: "Features", path: ROUTES.WEBSITE.FEATURES },
  //       { label: "How It Works", path: ROUTES.WEBSITE.HOW_IT_WORKS },
  //       { label: "FAQ", path: ROUTES.WEBSITE.FAQ },
  //       { label: "Trusted By", path: ROUTES.WEBSITE.TRUSTED_BY },
  //       { label: "Banners", path: ROUTES.WEBSITE.BANNER },
  //       { label: "Blog", path: ROUTES.WEBSITE.BLOG },
  //       { label: "Contact Enquiries", path: ROUTES.WEBSITE.CONTACT_ENQUIRIES },
  //     ],
  //   },
  //   {
  //     label: "Finance Management",
  //     children: [
  //       { label: "Income & Expense", path: ROUTES.FINANCE.INCOME_EXPENSE },
  //       { label: "Withdrawal", path: ROUTES.FINANCE.WITHDRAWAL },
  //       { label: "Refund Policy", path: ROUTES.FINANCE.REFUND_POLICY },
  //     ],
  //   },
  //   {
  //     label: "Legal Documents",
  //     children: [
  //       { label: "Terms & Conditions", path: ROUTES.WEBSITE.TERMS_CONDITION },
  //       { label: "Privacy Policy", path: ROUTES.WEBSITE.PRIVACY_POLICY },
  //       { label: "Refund Policy", path: ROUTES.FINANCE.REFUND_POLICY },
  //       { label: "Legality", path: ROUTES.WEBSITE.LEGALITY },
  //     ],
  //   },
  //   {
  //     label: "Question Management",
  //     children: [
  //       { label: "Questions", path: ROUTES.QUESTIONS.BASE },
  //       { label: "Copy Questions", path: ROUTES.QUESTIONS.COPY },
  //       { label: "Subjects & Subtopics", path: ROUTES.QUESTIONS.SUBJECT },
  //     ],
  //   },
  //   { label: "Youtube Visuals", path: ROUTES.YOUTUBE_VISUALS },
  //   { label: "Social Media Engage", path: ROUTES.SOCIAL_MEDIA_ENGAGE },
  //   { label: "Coupon Code", path: ROUTES.COUPON.BASE },
  //   { label: "SETTING", path: ROUTES.SETTINGS },
  //   { label: "Payment Message", path: ROUTES.PAYMENT_MESSAGE },
  //   { label: "Classes", path: ROUTES.CLASSES.BASE },
  //   { label: "User Admin", path: ROUTES.USER_ADMIN.BASE },
  // ];

  const menuItems = [
    { label: MENU_LABELS.DASHBOARD.label, path: ROUTES.HOME, value: MENU_LABELS.DASHBOARD.value },
    {
      label: MENU_LABELS.FLAG_ISSUES.label,
      value: MENU_LABELS.FLAG_ISSUES.value,
      children: [
        { label: MENU_LABELS.USER_REPORT.label, path: ROUTES.REPORTS.USER, value: MENU_LABELS.USER_REPORT.value },
        { label: MENU_LABELS.QUESTIONS_REPORT.label, path: ROUTES.REPORTS.QUESTION, value: MENU_LABELS.QUESTIONS_REPORT.value },
        { label: MENU_LABELS.RESULT_REPORT.label, path: ROUTES.REPORTS.RESULT, value: MENU_LABELS.RESULT_REPORT.value },
      ],
    },
    {
      label: MENU_LABELS.REPORTS.label,
      value: MENU_LABELS.REPORTS.value,
      children: [
        { label: MENU_LABELS.CONTEST_WISE_EARNING.label, path: ROUTES.EARNINGS.CONTEST_WISE, value: MENU_LABELS.CONTEST_WISE_EARNING.value },
        { label: MENU_LABELS.SUBJECT_WISE_EARNING.label, path: ROUTES.EARNINGS.SUBJECT_WISE, value: MENU_LABELS.SUBJECT_WISE_EARNING.value },
        { label: MENU_LABELS.SLOT_TIME_EARNING.label, path: ROUTES.EARNINGS.SLOT_TIME, value: MENU_LABELS.SLOT_TIME_EARNING.value },
        { label: MENU_LABELS.USER_EARNING.label, path: ROUTES.EARNINGS.USER, value: MENU_LABELS.USER_EARNING.value },
        { label: MENU_LABELS.CLASSES_EARNING.label, path: ROUTES.EARNINGS.CLASSES, value: MENU_LABELS.CLASSES_EARNING.value },
      ],
    },
    {
      label: MENU_LABELS.USERS.label,
      value: MENU_LABELS.USERS.value,
      children: [
        { label: MENU_LABELS.ALL_USERS.label, path: ROUTES.USERS.BASE, value: MENU_LABELS.ALL_USERS.value },
        { label: MENU_LABELS.USERDATA.label, path: ROUTES.USERS.DETAIL, value: MENU_LABELS.USERDATA.value },
        { label: MENU_LABELS.ADD_NEW_USER.label, path: ROUTES.USERS.ADD, value: MENU_LABELS.ADD_NEW_USER.value },
        { label: MENU_LABELS.KYC_VERIFICATION.label, path: ROUTES.USERS.KYC, value: MENU_LABELS.KYC_VERIFICATION.value },
      ],
    },
    {
      label: MENU_LABELS.CONTEST_MANAGEMENT.label,
      value: MENU_LABELS.CONTEST_MANAGEMENT.value,
      children: [
        { label: MENU_LABELS.ALL_CONTESTS.label, path: ROUTES.CONTEST.BASE, value: MENU_LABELS.ALL_CONTESTS.value },
        { label: MENU_LABELS.CONTEST_TYPES.label, path: ROUTES.CONTEST.TYPE, value: MENU_LABELS.CONTEST_TYPES.value },
        { label: MENU_LABELS.CONTEST_EARNINGS.label, path: ROUTES.EARNINGS.CONTEST_WISE, value: MENU_LABELS.CONTEST_EARNINGS.value },
        { label: MENU_LABELS.GOAL_TYPES.label, path: ROUTES.GOAL, value: MENU_LABELS.GOAL_TYPES.value },
        { label: MENU_LABELS.EXAM_TYPES.label, path: ROUTES.EXAM_TYPE, value: MENU_LABELS.EXAM_TYPES.value },
      ],
    },
    {
      label: MENU_LABELS.COURSES.label,
      value: MENU_LABELS.COURSES.value,
      children: [
        { label: MENU_LABELS.ALL_COURSES.label, path: ROUTES.COURSES.BASE, value: MENU_LABELS.ALL_COURSES.value },
        { label: MENU_LABELS.MODULE.label, path: ROUTES.COURSES.MODULE, value: MENU_LABELS.MODULE.value },
        { label: MENU_LABELS.COURSE_LECTURES.label, path: ROUTES.COURSES.LECTURES, value: MENU_LABELS.COURSE_LECTURES.value },
        { label: MENU_LABELS.COURSE_PURCHASE.label, path: ROUTES.COURSES.PURCHASE, value: MENU_LABELS.COURSE_PURCHASE.value },
        { label: MENU_LABELS.COURSE_FAQ.label, path: ROUTES.COURSES.FAQ, value: MENU_LABELS.COURSE_FAQ.value },
      ],
    },
    {
      label: MENU_LABELS.WORKSHOPS.label,
      value: MENU_LABELS.WORKSHOPS.value,
      children: [
        { label: MENU_LABELS.ALL_WORKSHOPS.label, path: ROUTES.WORKSHOPS.BASE, value: MENU_LABELS.ALL_WORKSHOPS.value },
        { label: MENU_LABELS.WORKSHOP_REGISTER.label, path: ROUTES.WORKSHOPS.REGISTER, value: MENU_LABELS.WORKSHOP_REGISTER.value },
        { label: MENU_LABELS.WORKSHOP_LECTURES.label, path: ROUTES.WORKSHOPS.LECTURES, value: MENU_LABELS.WORKSHOP_LECTURES.value },
        { label: MENU_LABELS.WORKSHOP_TESTIMONIALS.label, path: ROUTES.WORKSHOPS.TESTIMONIALS, value: MENU_LABELS.WORKSHOP_TESTIMONIALS.value },
        { label: MENU_LABELS.WORKSHOP_FAQ.label, path: ROUTES.WORKSHOPS.FAQ, value: MENU_LABELS.WORKSHOP_FAQ.value },
      ],
    },
    {
      label: MENU_LABELS.WEBSITE_CONTENT.label,
      value: MENU_LABELS.WEBSITE_CONTENT.value,
      children: [
        { label: MENU_LABELS.INTERFACE.label, path: ROUTES.WEBSITE.INTERFACE, value: MENU_LABELS.INTERFACE.value },
        { label: MENU_LABELS.ABOUT_US.label, path: ROUTES.WEBSITE.ABOUT_US, value: MENU_LABELS.ABOUT_US.value },
        { label: MENU_LABELS.FEATURES.label, path: ROUTES.WEBSITE.FEATURES, value: MENU_LABELS.FEATURES.value },
        { label: MENU_LABELS.HOW_IT_WORKS.label, path: ROUTES.WEBSITE.HOW_IT_WORKS, value: MENU_LABELS.HOW_IT_WORKS.value },
        { label: MENU_LABELS.FAQ.label, path: ROUTES.WEBSITE.FAQ, value: MENU_LABELS.FAQ.value },
        { label: MENU_LABELS.TRUSTED_BY.label, path: ROUTES.WEBSITE.TRUSTED_BY, value: MENU_LABELS.TRUSTED_BY.value },
        { label: MENU_LABELS.BANNERS.label, path: ROUTES.WEBSITE.BANNER, value: MENU_LABELS.BANNERS.value },
        { label: MENU_LABELS.BLOG.label, path: ROUTES.WEBSITE.BLOG, value: MENU_LABELS.BLOG.value },
        { label: MENU_LABELS.CONTACT_ENQUIRIES.label, path: ROUTES.WEBSITE.CONTACT_ENQUIRIES, value: MENU_LABELS.CONTACT_ENQUIRIES.value },
      ],
    },
    {
      label: MENU_LABELS.FINANCE_MANAGEMENT.label,
      value: MENU_LABELS.FINANCE_MANAGEMENT.value,
      children: [
        { label: MENU_LABELS.INCOME_EXPENSE.label, path: ROUTES.FINANCE.INCOME_EXPENSE, value: MENU_LABELS.INCOME_EXPENSE.value },
        { label: MENU_LABELS.WITHDRAWAL.label, path: ROUTES.FINANCE.WITHDRAWAL, value: MENU_LABELS.WITHDRAWAL.value },
        { label: MENU_LABELS.WITHDRAWAL_REQUEST.label, path: ROUTES.FINANCE.WITHDRAWAL_REQUEST, value: MENU_LABELS.WITHDRAWAL_REQUEST.value },
        { label: MENU_LABELS.REFUND_POLICY.label, path: ROUTES.FINANCE.REFUND_POLICY, value: MENU_LABELS.REFUND_POLICY.value },
      ],
    },
    {
      label: MENU_LABELS.LEGAL_DOCUMENTS.label,
      value: MENU_LABELS.LEGAL_DOCUMENTS.value,
      children: [
        { label: MENU_LABELS.TERMS_CONDITIONS.label, path: ROUTES.WEBSITE.TERMS_CONDITION, value: MENU_LABELS.TERMS_CONDITIONS.value },
        { label: MENU_LABELS.PRIVACY_POLICY.label, path: ROUTES.WEBSITE.PRIVACY_POLICY, value: MENU_LABELS.PRIVACY_POLICY.value },
        { label: MENU_LABELS.REFUND_POLICY.label, path: ROUTES.FINANCE.REFUND_POLICY, value: MENU_LABELS.REFUND_POLICY.value },
        { label: MENU_LABELS.LEGALITY.label, path: ROUTES.WEBSITE.LEGALITY, value: MENU_LABELS.LEGALITY.value },
      ],
    },
    {
      label: MENU_LABELS.QUESTION_MANAGEMENT.label,
      value: MENU_LABELS.QUESTION_MANAGEMENT.value,
      children: [
        { label: MENU_LABELS.QUESTIONS.label, path: ROUTES.QUESTIONS.BASE, value: MENU_LABELS.QUESTIONS.value },
        { label: MENU_LABELS.COPY_QUESTIONS.label, path: ROUTES.QUESTIONS.COPY, value: MENU_LABELS.COPY_QUESTIONS.value },
        { label: MENU_LABELS.SUBJECTS_SUBTOPICS.label, path: ROUTES.QUESTIONS.SUBJECT, value: MENU_LABELS.SUBJECTS_SUBTOPICS.value },
      ],
    },
    { label: MENU_LABELS.YOUTUBE_VISUALS.label, path: ROUTES.YOUTUBE_VISUALS, value: MENU_LABELS.YOUTUBE_VISUALS.value },
    { label: MENU_LABELS.SOCIAL_MEDIA_ENGAGE.label, path: ROUTES.SOCIAL_MEDIA_ENGAGE, value: MENU_LABELS.SOCIAL_MEDIA_ENGAGE.value },
    { label: MENU_LABELS.COUPON_CODE.label, path: ROUTES.COUPON.BASE, value: MENU_LABELS.COUPON_CODE.value },
    { label: MENU_LABELS.MOCK_TEST_DISCOUNT.label, path: ROUTES.MOCK_TEST_DISCOUNT, value: MENU_LABELS.MOCK_TEST_DISCOUNT.value },
    { label: MENU_LABELS.FREE_MOCK_TEST.label, path: ROUTES.FREE_MOCK_TEST, value: MENU_LABELS.FREE_MOCK_TEST.value },
    { label: MENU_LABELS.SETTING.label, path: ROUTES.SETTINGS, value: MENU_LABELS.SETTING.value },
    { label: MENU_LABELS.PAYMENT_MESSAGE.label, path: ROUTES.PAYMENT_MESSAGE, value: MENU_LABELS.PAYMENT_MESSAGE.value },
    { label: MENU_LABELS.CLASSES.label, path: ROUTES.CLASSES.BASE, value: MENU_LABELS.CLASSES.value },
    { label: MENU_LABELS.USER_ADMIN.label, path: ROUTES.USER_ADMIN.BASE, value: MENU_LABELS.USER_ADMIN.value },
  ];

  const toggleMenu = (label) => {
    setOpenMenus((prev) => ({
      ...prev,
      [label]: !prev[label],
    }));
  };

  const isActive = (path) => pathname === path;

  const handleLinkClick = () => setSidebarOpen(false);

  const renderMenu = (items, level = 0) => (
    <ul className={`${level > 0 ? "pl-3 sm:pl-4" : ""} space-y-1`}>
      {items.map((item) => (
        <li key={item.path || item.label}>
          <div>
            <Link
              to={item.path || "#"}
              onClick={(e) => {
                if (item.children) {
                  e.preventDefault();
                  toggleMenu(item.label);
                } else {
                  handleLinkClick();
                }
              }}
              className={`flex items-center justify-between gap-2 px-3 sm:px-4 py-2.5 rounded-xl text-xs sm:text-sm font-bold transition-all duration-300 ${isActive(item.path) ? "bg-primary text-white shadow-theme" : "text-foreground hover:bg-secondary hover:text-primary"}`}
            >
              <span className="truncate">{item.label}</span>
              {item.children && <span className="ml-2 shrink-0">{openMenus[item.label] ? <IoChevronUp className="w-4 h-4" /> : <IoChevronDown className="w-4 h-4" />}</span>}
            </Link>

            {item.children && openMenus[item.label] && renderMenu(item.children, level + 1)}
          </div>
        </li>
      ))}
    </ul>
  );

  const filterMenuByAccess = (items) => {
    // If admin → show everything
    if (user1?.userType === "admin") {
      return items;
    }

    // If telecaller → show only accessed menus
    return items
      .filter((item) => {
        return user1?.access?.includes(item.value) || item.children?.some((child) => user1?.access?.includes(child.value));
      })
      .map((item) => ({
        ...item,
        children: item.children ? item.children.filter((child) => user1?.access?.includes(child.value)) : undefined,
      }));
  };
  const allowedMenu = filterMenuByAccess(menuItems);

  useEffect(() => {
    const handleClickOutside = (e) => {
      if (sidebarRef.current && !sidebarRef.current.contains(e.target)) {
        setSidebarOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [setSidebarOpen]);

  const getUserDataById = useCallback(async () => {
    await dispatch(getSingleStudent(user1?._id));
  }, [dispatch, user1?._id]);

  useEffect(() => {
    if (user1?._id) {
      getUserDataById();
    }
  }, [user1?._id, getUserDataById]);

  useEffect(() => {
    if (!singleUserData?.access) return;
    if (user1?.access !== singleUserData?.access) {
      const updatedUser = { ...user1, access: singleUserData?.access };
      dispatch(setUser(updatedUser));
    }
  }, [dispatch, singleUserData?.access, user1]);

  return (
    <aside ref={sidebarRef} className={`fixed top-16 md:top-20 left-0 z-40 w-[85vw] max-w-[288px] sm:w-72 bg-card border-r border-border shadow-theme transform ${isOpen ? "translate-x-0" : "-translate-x-full"} lg:translate-x-0 transition-transform duration-300 ease-in-out rounded-tr-[18px] rounded-br-[18px] py-2 font-sans`}>
      <div
        className="flex flex-col flex-1 overflow-y-auto custom-scrollbar z-40 
        h-[calc(100dvh-7rem)]
        sm:h-[calc(100dvh-8rem)]
        lg:h-[calc(100dvh-7rem)]"
      >
        <nav className="ps-3 pe-2 sm:ps-4">{renderMenu(allowedMenu)}</nav>
      </div>
    </aside>
  );
};

export default Sidebar;
